(function () {
  // The <source> in the markup only carries a data-src, not a real
  // src — the video tag itself has preload="none" and no autoplay
  // attribute, so the browser never starts fetching it on page load.
  // Only once the section is actually about to scroll into view does
  // this swap data-src onto src, call .load(), and start it playing
  // — it still ends up looping continuously once on screen, it just
  // no longer competes for bandwidth with everything above the fold
  // before the visitor has even scrolled anywhere near it.
  function initLazyVideo(video) {
    var source = video.querySelector('source[data-src]');
    var started = false;

    function start() {
      if (started) return;
      started = true;
      if (source) {
        source.src = source.getAttribute('data-src');
        video.load();
      }
      video.play();
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
              observer.disconnect();
            }
          });
        },
        { rootMargin: '200px' }
      );
      observer.observe(video);
    } else {
      // No IntersectionObserver support — fall back to loading it
      // right away rather than never loading at all.
      start();
    }
  }

  function initVideoToggle(video) {
    var toggle = video.parentElement && video.parentElement.querySelector('[data-video-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        toggle.classList.remove('is-paused');
        toggle.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        toggle.classList.add('is-paused');
        toggle.setAttribute('aria-label', 'Play video');
      }
    });
  }

  // Always exactly 8 days out regardless of the ZIP entered — the
  // ZIP is just a gate the visitor has to clear to see the date, not
  // an input into a real shipping-time calculation.
  function formatDeliveryDate() {
    var date = new Date();
    date.setDate(date.getDate() + 8);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  }

  function initDeliveryWidget(widget) {
    var input = widget.querySelector('[data-zip-input]');
    var result = widget.querySelector('[data-delivery-result]');
    var dateEl = widget.querySelector('[data-delivery-date]');
    if (!input || !result || !dateEl) return;

    var STORAGE_KEY = 'productDeliveryZip';

    function showDate() {
      dateEl.textContent = formatDeliveryDate();
      result.hidden = false;
    }

    // No submit button — the date populates as soon as a valid 5-digit
    // ZIP is typed, and hides again if the field is edited back down
    // below 5 digits.
    input.addEventListener('input', function () {
      var zip = input.value.trim();
      if (!/^\d{5}$/.test(zip)) {
        result.hidden = true;
        return;
      }
      try {
        localStorage.setItem(STORAGE_KEY, zip);
      } catch (e) {
        // localStorage unavailable (private browsing, etc.) — the
        // date still shows for this page view, it just won't be
        // remembered on the next visit.
      }
      showDate();
    });

    var savedZip = '';
    try {
      savedZip = localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      // no-op
    }
    if (savedZip) {
      input.value = savedZip;
      showDate();
    }
  }

  function init() {
    // Not scoped to a single wrapping section — the delivery widget
    // moved up into the shipping-info rows in main-product.liquid,
    // while the video toggle stays in its own video-only section, so
    // each is found independently wherever it happens to be.
    document.querySelectorAll('[data-product-video]').forEach(function (video) {
      initLazyVideo(video);
      initVideoToggle(video);
    });
    document.querySelectorAll('[data-delivery-widget]').forEach(initDeliveryWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
